module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-HeavyItalic.woff2?8800da9db1ac9d1f4102ee2a78d87ce6";